import React from "react";
import { StyleguideDocument } from "tsi-common-react/src/styleguide/StyleguideDocument";

import { Context } from "@reactivated";

import { Template as FinancingModal } from "../../templates/FinancingModalTemplate";
import { Template as SessionKeepAlive } from "../../templates/SessionKeepAliveTemplate";

type IProps = {
    storybook: boolean;
    children?: React.ReactNode;
};

/**
 * Stearns' styleguide document chrome, shared by the block and element
 * fixture templates. Mirrors the legacy _styleguide_base.html: the
 * #main-content wrapper and the keep-alive / financing furniture the
 * production PageSkeleton also mounts.
 */
export const StyleguideChrome = (props: IProps): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    return (
        <StyleguideDocument
            storybook={props.storybook}
            // Stearns is en-us only (PageSkeleton hardcodes it the same way).
            htmlLang="en-us"
            designVersion={chrome.design_version}
            bodyId={chrome.body_id}
            legacyJsUrl={`${chrome.static_base}dist2/legacy.js`}
            bodyEnd={
                <>
                    <SessionKeepAlive />
                    <FinancingModal />
                </>
            }
        >
            {props.storybook ? (
                props.children
            ) : (
                <main id="main-content">{props.children}</main>
            )}
        </StyleguideDocument>
    );
};
